import { render, staticRenderFns } from "./pickUp.vue?vue&type=template&id=8e81125e&scoped=true&"
import script from "./pickUp.vue?vue&type=script&lang=js&"
export * from "./pickUp.vue?vue&type=script&lang=js&"
import style0 from "./pickUp.vue?vue&type=style&index=0&id=8e81125e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e81125e",
  null
  
)

export default component.exports